import BGPH1 from '../../assets/images/backgrounds/bnrimage.jpg'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import React, { useState, useEffect, useMemo } from 'react'
//import { Container } from "react-bootstrap";
//import Header from "components/Header";
import { TableHeader, Pagination, Searchdata } from '../DataTable';
import Navbar from '../Navbar/Main'
import Footer from '../Footer/Main'
import DOMPurify from 'dompurify';
// import Service from '../Main'
// import onSubmitForm from '../Main'

const escapeRegExp = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Plain-text highlights for React (case-insensitive). */
const highlightTextToReact = (text, query) => {
  const raw = String(text ?? "");
  const q = (query ?? "").trim();
  if (!q) return raw;
  try {
    const parts = raw.split(new RegExp(`(${escapeRegExp(q)})`, "gi"));
    return parts.map((part, i) =>
      part.toLowerCase() === q.toLowerCase() ? (
        <mark key={i} className="search-highlight bg-warning bg-opacity-50 px-0 rounded">
          {part}
        </mark>
      ) : (
        part
      )
    );
  } catch {
    return raw;
  }
};

/** Sanitized HTML → plain text, then highlight (avoids breaking tags inside summary). */
const highlightSummaryPlain = (html, query) => {
  const safe = DOMPurify.sanitize(String(html ?? ""));
  let plain = "";
  if (typeof document !== "undefined") {
    const tmp = document.createElement("div");
    tmp.innerHTML = safe;
    plain = tmp.textContent || tmp.innerText || "";
  } else {
    plain = safe.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  }
  return highlightTextToReact(plain, query);
};

export const Resultdata = () => {
    
   const [doc, setDoc] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [rawSearch, setRawSearch] = useState("");
    const [search, setSearch] = useState("");
    const [sorting, setSorting] = useState({ field: "", order: "" });
    const [typeFilter, setTypeFilter] = useState("all"); // all | pdf | web | other
    const [searchIn, setSearchIn] = useState("all"); // all | title | summary | link

    const ITEMS_PER_PAGE = 10;

    const headers = [
        // { name: "Date", field: "Date", sortable: false },
        { name: "Search result ", field: "Search result ", sortable: false },
    ];
   const [loading, setLoading] = useState(true);
   useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`/search`);
        const docData = await response.json();
        setDoc(Array.isArray(docData) ? docData : []);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); 

  // Debounce search input for better UX
  useEffect(() => {
    const t = setTimeout(() => {
      setSearch(rawSearch);
      setCurrentPage(1);
    }, 200);
    return () => clearTimeout(t);
  }, [rawSearch]);

  const detectType = (link = "") => {
    const l = String(link || "").toLowerCase();
    if (l.endsWith(".pdf")) return "pdf";
    if (l.startsWith("http://") || l.startsWith("https://")) return "web";
    if (l.startsWith("/")) return "web";
    return "other";
  };

  const docData = useMemo(() => {
    let computeddoc = Array.isArray(doc) ? [...doc] : [];

    // Type filter
    if (typeFilter !== "all") {
      computeddoc = computeddoc.filter((d) => detectType(d?.link) === typeFilter);
    }

    // Text search (safe + configurable)
    const q = (search || "").trim().toLowerCase();
    if (q) {
      const norm = (v) => String(v ?? "").toLowerCase();
      computeddoc = computeddoc.filter((d) => {
        const title = norm(d?.title);
        const summary = norm(d?.summary);
        const link = norm(d?.link);
        if (searchIn === "title") return title.includes(q);
        if (searchIn === "summary") return summary.includes(q);
        if (searchIn === "link") return link.includes(q);
        return title.includes(q) || summary.includes(q) || link.includes(q);
      });
    }

    const computedCount = computeddoc.length;

    //Sorting doc
    if (sorting.field) {
        const reversed = sorting.order === "asc" ? 1 : -1;
        computeddoc = computeddoc.sort(
            (a, b) =>
                reversed * a[sorting.field].localeCompare(b[sorting.field])
        );
    }

    //Current Page slice
    const pageRows = computeddoc.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
    return { pageRows, computedCount };
}, [doc, currentPage, search, sorting, typeFilter, searchIn]);

  useEffect(() => {
    setTotalItems(docData.computedCount);
  }, [docData.computedCount]);

        const [clicked, setClicked] = useState(null);

  return (
    <>
    <Navbar/>
        <div className="stricky-header stricked-menu main-menu">
            <div className="sticky-header__content"></div>
        </div>
        <section className="page-header">
            <div className="page-header__bg slider-one__image"   ></div>
              <div className="container">
                  <div className="search-popup__content">
                      <div className ="mandate1">
                        <p>
                        Rwanda's Central Bank mandated to ensure price stability and a sound financial system
                        </p>
                    </div>
                  <form style={{ overflow: 'visible' }} action="/resultdata" onSubmit={e =>
                      e.preventDefault()}>                  
                      <Searchdata
                        //   style={{ width: '80%', borderTopLeftRadius: '50%', borderBottomLeftRadius: '50%' }}
                      onSearch={value => { setRawSearch(value); }} />
                   <button type="submit" aria-label="search submit" className="thm-btn">
                    <i className="icon-magnifying-glass"></i>
                </button>
                      </form>
                      </div>
            </div>
        </section>
        <section className="service-details">
            <div className="container">
                <div className="row row-gutter-y-10">
                      <div className="col-lg-12">

                        <div className="service-details__content">
                       
                            <div className="row row-gutter-y-30">
                                <div className="col-md-12">
                                  <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-3">
                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                      <label className="small text-muted mb-0">Type</label>
                                      <select
                                        className="form-select form-select-sm"
                                        style={{ width: 160 }}
                                        value={typeFilter}
                                        onChange={(e) => { setTypeFilter(e.target.value); setCurrentPage(1); }}
                                      >
                                        <option value="all">All</option>
                                        <option value="pdf">PDF</option>
                                        <option value="web">Web</option>
                                        <option value="other">Other</option>
                                      </select>

                                      <label className="small text-muted mb-0 ms-2">Search in</label>
                                      <select
                                        className="form-select form-select-sm"
                                        style={{ width: 180 }}
                                        value={searchIn}
                                        onChange={(e) => { setSearchIn(e.target.value); setCurrentPage(1); }}
                                      >
                                        <option value="all">Title + Summary + Link</option>
                                        <option value="title">Title only</option>
                                        <option value="summary">Summary only</option>
                                        <option value="link">Link only</option>
                                      </select>
                                    </div>

                                    <div className="small text-muted">
                                      {loading ? null : (
                                        <>Showing {docData.pageRows.length} of {docData.computedCount}</>
                                      )}
                                    </div>
                                  </div>
   
                        {loading ? (
                
                <p></p>
                    ) : docData && docData.pageRows.length > 0 ? (
                        
                        <>  
                       <div className="loan-comparison__body" id="compare-emi-1">
                <div className="compare-table_search table-responsive">

                  <table className="table">
                  <TableHeader
                            headers={headers}
                            onSorting={(field, order) =>
                                setSorting({ field, order })
                            }
                        />
                                <tbody>
                                   
                         {
                                           docData ? docData.pageRows.map((d, index) => (
                                            
                                            <tr key={`${d?.title || "item"}-${d?.link || index}`}>
                                                <td>
                                                <div className="accrodion-grp service-details__accrodion" data-grp-name="service-details__accrodion-1">

                                        <div className={`accrodion  wow fadeInUp ${index === clicked ? "active" : ""}`} key={index} data-wow-delay="0ms">
                                            <div className="accrodion-title" onClick={() => setClicked(clicked === index ? null : index)}>
                                                <h4>{highlightTextToReact(d.title, search)}</h4>
                                                <span className="accrodion-icon"></span>
                                            </div>
                                            {index === clicked && 
                                            <div className="accrodion-content">
                                                <div className="inner_doc" >
                                                    <p>
                                                      {(search || "").trim() ? (
                                                        <div className="search-result-summary">
                                                          {highlightSummaryPlain(d.summary, search)}
                                                        </div>
                                                      ) : (
                                                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`${d.summary}`)}} />
                                                      )}
                        </p>
                                                    <Link to={d.link} target="_blank">View details <i className="fa fa-file-pdf"></i></Link>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                                </td>
                                            </tr>
                                     
                               )) : <tr key=""><td>Loading.....</td></tr>
                            }
                                </tbody>
                  </table>
                  <div className="col-md-4">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                        </div>
                        </div>
                      </> 
                         ) : (
                        <p>No result found</p>
                                      )}
                                      
                            </div>
                            </div>
                    </div>
                    </div>
                    
                    <div className="col-lg-4">
                    </div>
                </div>
            </div>
        </section>
        <Link to="#" data-target="html" className="scroll-to-target scroll-to-top"><i className="fa fa-angle-up"></i></Link>
        <Footer/>
    </>
  )
}
